/**
 * Determine Whether Two Time Ranges Overlap
 * For more information, check out {@link https://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap/325964}
 * @param {string} startA - The start time of the first time range, with the format HH:mm
 * @param {string} endA - The end time of the first time range, with the format HH:mm
 * @param {string} startB - The start time of the second time range, with the format HH:mm
 * @param {string} endB - The end time of the second dattimee range, with the format HH:mm
 * @return {boolean} - Returns true if the time ranges Overlap
 */
const timeRangesOverlap = (
    startA: string,
    endA: string,
    startB: string,
    endB: string
): boolean =>
    (startA < endB && endA > startB) || (startA < endB && startB < endA);

export default timeRangesOverlap;
